<template>
  <div class="api-info-block">
    <h3 class="api-info-block__title" @click="handleChange">
      <span>{{ title }}</span>
      <span>
        <Icon v-if="isPickUp" type="ios-arrow-down" />
        <Icon v-else type="ios-arrow-up" />
      </span>
    </h3>

    <div :class="['api-info-block__content', isPickUp ? 'open' : 'close']">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApiInfoBlock",

  props: {
    value: {
      type: Boolean,
      default: true
    },

    title: {
      type: String
    }
  },

  watch: {
    value: {
      handler(newVal) {
        this.isPickUp = newVal;
      },
      immediate: true
    },

    isPickUp() {
      this.$emit("input", this.isPickUp);
    }
  },

  data() {
    return {
      isPickUp: true
    };
  },

  methods: {
    handleChange() {
      this.isPickUp = !this.isPickUp;
    }
  }
};
</script>

<style lang="less">
.api-info-block {
  padding-bottom: 16px;
  &__title {
    line-height: 48px;
    border-bottom: 1px solid @color-border-default;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  &__content {
    overflow: hidden;
    transition: all 0.3s;

    &.open {
      opacity: 1;
      height: auto;
    }

    &.close {
      opacity: 0;
      height: 0;
    }
  }
}
</style>
